/* eslint-disable */

import * as Apollo from '@apollo/client';
import { DocumentNode } from 'graphql';
import * as Types from '@99designs/graph-utils/types';

export type FixedPriceProjectProductsByKeysQueryVariables = Types.Exact<{
    keys?: Types.Maybe<Array<Types.Scalars['String']> | Types.Scalars['String']>;
}>;

export type FixedPriceProjectProductsByKeysQuery = {
    __typename: 'Query';
    productsByKeys: Array<
        | {
              __typename: 'ProductFixedPriceProject';
              title: string;
              description: string;
              key: string;
              details: Array<{
                  __typename: 'ProductPackageDetails';
                  title: string;
                  description: string;
              }>;
              pricing: {
                  __typename: 'FixedPrice';
                  earningsInUsd: number;
                  amounts: Array<{ __typename: 'Money'; amountInCents: number; currency: string }>;
                  amount: { __typename: 'Money'; amountInCents: number; currency: string };
              };
          }
        | { __typename: 'ProductContest'; key: string }
        | { __typename: 'ProductQuotedProject'; key: string }
    >;
};

export const FixedPriceProjectProductsByKeysDocument: DocumentNode = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'FixedPriceProjectProductsByKeys' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'keys' } },
                    type: {
                        kind: 'ListType',
                        type: {
                            kind: 'NonNullType',
                            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
                        },
                    },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'productsByKeys' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'keys' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'keys' } },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'key' } },
                                {
                                    kind: 'InlineFragment',
                                    typeCondition: {
                                        kind: 'NamedType',
                                        name: { kind: 'Name', value: 'ProductFixedPriceProject' },
                                    },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'title' },
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'description' },
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'details' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'title' },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'description',
                                                            },
                                                        },
                                                    ],
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'pricing' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'amounts',
                                                            },
                                                            selectionSet: {
                                                                kind: 'SelectionSet',
                                                                selections: [
                                                                    {
                                                                        kind: 'Field',
                                                                        name: {
                                                                            kind: 'Name',
                                                                            value: 'amountInCents',
                                                                        },
                                                                    },
                                                                    {
                                                                        kind: 'Field',
                                                                        name: {
                                                                            kind: 'Name',
                                                                            value: 'currency',
                                                                        },
                                                                    },
                                                                ],
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'amount' },
                                                            selectionSet: {
                                                                kind: 'SelectionSet',
                                                                selections: [
                                                                    {
                                                                        kind: 'Field',
                                                                        name: {
                                                                            kind: 'Name',
                                                                            value: 'amountInCents',
                                                                        },
                                                                    },
                                                                    {
                                                                        kind: 'Field',
                                                                        name: {
                                                                            kind: 'Name',
                                                                            value: 'currency',
                                                                        },
                                                                    },
                                                                ],
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'earningsInUsd',
                                                            },
                                                        },
                                                    ],
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
};

/**
 * __useFixedPriceProjectProductsByKeysQuery__
 *
 * To run a query within a React component, call `useFixedPriceProjectProductsByKeysQuery` and pass it any options that fit your needs.
 * When your component renders, `useFixedPriceProjectProductsByKeysQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFixedPriceProjectProductsByKeysQuery({
 *   variables: {
 *      keys: // value for 'keys'
 *   },
 * });
 */
export function useFixedPriceProjectProductsByKeysQuery(
    baseOptions?: Apollo.QueryHookOptions<
        FixedPriceProjectProductsByKeysQuery,
        FixedPriceProjectProductsByKeysQueryVariables
    >
) {
    return Apollo.useQuery<
        FixedPriceProjectProductsByKeysQuery,
        FixedPriceProjectProductsByKeysQueryVariables
    >(FixedPriceProjectProductsByKeysDocument, baseOptions);
}
export function useFixedPriceProjectProductsByKeysLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        FixedPriceProjectProductsByKeysQuery,
        FixedPriceProjectProductsByKeysQueryVariables
    >
) {
    return Apollo.useLazyQuery<
        FixedPriceProjectProductsByKeysQuery,
        FixedPriceProjectProductsByKeysQueryVariables
    >(FixedPriceProjectProductsByKeysDocument, baseOptions);
}
export type FixedPriceProjectProductsByKeysQueryHookResult = ReturnType<
    typeof useFixedPriceProjectProductsByKeysQuery
>;
export type FixedPriceProjectProductsByKeysLazyQueryHookResult = ReturnType<
    typeof useFixedPriceProjectProductsByKeysLazyQuery
>;
export type FixedPriceProjectProductsByKeysQueryResult = Apollo.QueryResult<
    FixedPriceProjectProductsByKeysQuery,
    FixedPriceProjectProductsByKeysQueryVariables
>;
